import { createAction, props } from '@ngrx/store';
export const fetchCalcRangeInfo = createAction('[Range Data] Fetch Calc Range Info');
export const setCalcRangeInfoFetchSuccess = createAction('[Range Data] Fetch Calc Range Info Success', props());
